import React, { Suspense } from 'react';
import AppRoutes from '../../domains/routes';

const PageRoutes = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <AppRoutes />
  </Suspense>
);

export default PageRoutes;
